import {formControls} from './formControls';
import {FormFieldType} from './types';

export function getControlByType(type: FormFieldType) {
  return formControls[type];
}
